
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trichy",
      function () {
        return require("private-next-pages/trichy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trichy"])
      });
    }
  